<template>
  <div class="informationinfo"
    style="font-family: -apple-system-font,PingFang SC,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
    <div class="carousel">
      <video id="" autoplay muted loop preload="auto" style="z-index: 200; width: 100%; height: auto">
        <!-- <source type="video/mp4" src="../assets/images/banner.mp4" /> -->
      </video>
    </div>
    <div>
      <div class="box">
        <div style="font-size: 0.12rem !important; padding-top: 10px">
          <el-breadcrumb style="font-size: 0.12rem !important" separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/Information' }"
              style="font-size: 0.12rem !important">平台资讯</el-breadcrumb-item>
            <el-breadcrumb-item style="font-size: 0.12rem !important">新闻详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <br />
        <div v-if="tag == 'cn'">
          <div style="font-size: 0.24rem; font-weight: bold; width: 100%; text-align: center">
            “环境产业互联网平台生态共建工作会”在青举办
          </div>

          <div style="
              font-size: 0.14rem;
              padding: 0.1rem 0;
              color: #aaa;
              width: 100%;
              text-align: center;
            ">
            <i class="el-icon-time"></i>2021年5月8日
          </div>
          <div style="width: 100%; text-align: center">
            <!-- <el-button type="text" @click="openDialog"
              >《环卫产业互联网平台白皮书（2020）》下载</el-button
            > -->
            <!-- <a href="#" style="color:#409EFF" @click="openDialog">
              《环卫产业互联网平台白皮书（2020）》下载
            </a> -->
          </div>
          <br />
          <div class="article lh-36">
            2021年国家工信部发布第二个三年计划，全面提速我国工业互联网发展。为更快推进环境产业互联网平台生态共建工作，5月8日，青岛国真智慧科技有限公司在青岛举办“Eiiplat环境产业互联网平台共建工作会”，对生态共建工作进行总结与问题研讨，完成第三批生态共建伙伴入驻签约工作。
          </div>
          <div class="article lh-36">
            来自中国城市环境卫生协会、中国城市建设研究院、北京朝阳循环产业园、中环智慧环境有限公司及政府有关部门的领导、行业专家和共建转企业领导与会。
          </div>
          <div class="article lh-36">
            首先，青岛国真智慧科技有限公司曹曼董事长对环境产业互联网平台共建工作的开展情况和成果进行总结，安徽天健环保股份有限公司、北京中科博联科技集团有限公司、南京信业能源科技有限公司、上海太的信息科技有限公司、升禾城市环保科技股份有限公司、国网浙江综合能源服务有限公司、中再云图技术有限公司及政府有关部门的领导、行业专家及企业家对共建工作给予充分肯定，并进行了热烈讨论，推动了共建工作。
          </div>
          <!-- <el-col :span="12" style="text-align: right">
              <img style="width: 40%;margin-top:  -25px" src="../assets/images/book1.jpg" />
            </el-col> -->
          <div style="width:100%;text-align:center;padding:20px 0">
            <img style="width: 60%" src="../assets/images/gongjianhong.png" />
          </div>
          <div class="article lh-36">
            随后，会议进行了“Eiiplat环境产业互联网平台第三批生态共建伙伴入驻签约仪式”。本次参与共建的单位有：百沃星联(上海)环保科技有限公司、北京东土科技股份有限公司、青岛康恒环境股份有限公司、上海道客网络科技有限公司、上海昊沧系统控制技术有限责任公司、上海万位数字技术有限公司等。目前，已有超过20家行业机构、央企国企、上市企业等单位参与共建。
          </div>
          <div class="article lh-36">
            中国城市环境卫生协会徐文龙会长在会上总结发言。他表示，Eiiplat环境产业互联网平台从增效模式、平台架构、还有建设模式上不断优化迭代，尤其是“微平台”的提出，可以解决企业上平台难的问题，满足企业数据安全与发展需求；满足产业链建设和产业融合，实现企业之间的互联、互通和互动，与可持续增效共赢。中国城市环境卫生协会聚集一大批行业专家，作为提供技术交流和服务的平台，将为Eiiplat的进一步完善和推广应用提供更好的服务，为我国工业互联网和世界工业互联网之都建设贡献我们的全部力量。
          </div>
          <div class="article lh-36">
            Eiiplat环境产业互联网平台，己通过中环协组织的专家评审鉴定，填补了国内空白，处于国际先进水平。平台在商业模式、建设模式、构建方法与关键技术等方面做出了创新成果，具有明显增效功能和方便运营监管效果，是推动环境管理“一张网、一本账”的有效工具。
          </div>
          <div style="width:100%;text-align:center;padding:20px 0">
            <img style="width: 60%" src="../assets/images/gongjianhui.png" />
          </div>
          <div class="article lh-36">
            为加快平台的推广应用，满足企业数据保密的需求，国真智慧还创新开发出了与平台配套的“微平台”。“微平台”类似于“微信”，“微信”
            是消费互联网生态体系的细胞，服务于个人；而“微平台”是工业互联网的细胞，服务于企业。“微平台”是从平台中长出来的“软硬件产品”，它既拥有平台的功能，提供持续增效支撑，又能脱离平台使用，使数据得到保密，很好地解决了企业之间的方便和高效连接。
          </div>
          <div class="article lh-36">
            微平台的诞生开发，使“大平台+子平台+微平台”分增效共赢模式应运而生，可化解工业互联网平台建设和用平台过程中的难点，包括既能选用平台的功能，又能满足对数据保密和个性化的需求，整合行业内外一切可以整合的资源，确保行业平台每个单元模块的最优化，实现持续增效共赢，推动工业互联网生态系统建设的快速发展。
          </div>
          <div class="article lh-36">
            “微平台”是发展工业互联网和数字经济的一个核心产品，适用于各个行业，它能够保护企业数据、定制私有化部署，帮助企业更好地上平台用平台，促进产业的快速融合和世界工业互联网之都的建设，真正实现政府、企业和公众的共赢。“微平台”填补了企业交互环节的空白，由此催生新的工业互联网产业经济增长点，推动青岛乃至全国工业互联网大跨步发展。类似腾讯通过”微信”大大推动消费互联网的发展，青岛国真智慧也必将通过“微平台”大大推动工业互联网的发展。
          </div>

          <!-- <div class="lh-36">
            版权声明：本白皮书版权属于中国城市环境卫生协会，并受法律保护。转载、摘编或利用其它方式使用本白皮书文字或观点，请注明“来源：中国城市环境卫生协会”。违反上述声明者，将追究其相关法律责任。
          </div> -->
          <br />
          <br />
          <!-- <div class="lh-36">
            如有其他疑问，可与编制组联系，联系方式如下：<br />
            中环协智慧环卫专委会：zhihuihuanwei@126.com<br />
            主编：曹曼博士caoman@tianren.com<br />
            执行主编：吴健敏wujianmin@tianren.com<br />
          </div> -->
          <br />
        </div>
        <div v-if="tag == 'us'">
          <div style="width:100%;text-align:center">
            <span style="font-size: 0.24rem; font-weight: bold; width: 100%; text-align: center;font-style:italic">White
              Paper of Sanitation Industry Internet Platform (2020)
            </span>
            <span style="font-size: 0.24rem; font-weight: bold; width: 100%; text-align: center">is Now
              Available!</span>
          </div>

          <div style="
              font-size: 0.14rem;
              padding: 0.1rem 0;
              color: #aaa;
              width: 100%;
              text-align: center;
            ">
            <i class="el-icon-time"></i>November 22, 2020
          </div>
          <div style="width: 100%; text-align: center">
            <a href="#" style="border-bottom: 1px solid #409EFF; text-decoration: none;
" @click="openDialog">
              <span style="color:#409EFF;font-style:italic">White Paper of Sanitation Industry Internet Platform (2020)
              </span>
              <span style="color:#409EFF;">download</span>
            </a>
          </div>
          <br />
          <div class="article lh-36">
            The development of the industrial Internet is an important
            cornerstone of the fourth industrial revolution. The Industrial
            Internet is a new industrial ecology in which a new generation of
            information technology is deeply integrated with the industrial
            economy, which can promote productivity change, thus reducing
            production costs and achieving more efficient and high-quality
            production.
          </div>
          <div class="article lh-36">
            Recently, led by the China Association of Urban Environmental
            Sanitation (hereinafter referred to as "CAUES"), and under the
            guidance of a number of industry leaders and experts, the first
            white paper of the sanitation industry - White Paper of Sanitation
            Industry Internet Platform (2020) was officially released, which is
            a symbol of the integration of the industrial Internet and the
            sanitation industry.
          </div>
          <div class="article lh-36">
            The white paper is based on the national development strategy of
            smartization and networking and the actual situation and development
            trend of the sanitation industry, and is a thematic research report
            written after a year's investigation and research. It aims to call
            on all sectors of the society to pay attention to the policy
            research, technical input, standard construction and service
            application of the intelligent + sanitation industry, and jointly
            promote the innovative development of the sanitation industry.
          </div>
          <div style="width:100%;text-align:center;padding:20px 0">
            <img style="width: 40%" src="../assets/images/book.jpg" />
          </div>
          <div class="article lh-36">
            The white paper consists of seven sections: Preface, The Current
            Situation, Platforms, Structure, Design, Standards and
            Recommendations. By studying the current situation of the
            smartization of the sanitation industry, the concept of an Internet
            platform for the sanitation industry is put forward, the
            relationship with related industries is sorted out and a grand
            blueprint for an Internet platform for the sanitation industry is
            described. At the same time, based on the prospective needs of
            innovative technology and industrial development, a relevant
            standard system for the Internet platform for sanitation industry is
            proposed, in order to provide technical support for the platform's
            ground application and strategic deployment, and to clarify ideas
            for the next step of implementation.
          </div>
          <div class="article lh-36">
            The internet platform for the sanitation industry is a cloud
            platform for the digital, networked and smartized needs of the
            sanitation industry, which can build a service system based on
            massive data collection, aggregation and analysis, thus supporting
            the ubiquitous connection, flexible supply and efficient allocation
            of industrial resources. The Internet platform for the sanitation
            industry is a new infrastructure for vertical industries in the
            digital era, which should be built under the leadership of
            outstanding enterprises in the industry and provided to the majority
            of practitioners in the industrial ecology in the form of a sharing
            economy. From the perspective of the whole industry chain, it can
            integrate resources and optimise the value chain, reduce industrial
            operating costs, improve the quality and efficiency of the whole
            industry operation, and create better experience and social value
            for customers by taking advantage of the new industrial ecology.
          </div>
          <div class="article lh-36">
            The Internet platform for the sanitation industry proposed in the
            white paper is based on the core of "creating new value", and
            pioneers the profit model of "sharing and synergy" and the
            construction model of "big platform + multi-centre". All the
            platform subjects follow the principle of co-creation and sharing of
            user value, and operate in a way of dividing and increasing
            efficiency to achieve cost reduction and increase revenue for end
            users and improve quality of service. Qingdao Guozhen Smart
            Technology Co., the leader of the platform, actively responded to
            the call of the CAUES, and took the initiative to take charge of the
            platform's early development and late co-ordination work. Under the
            guidance of the Smart Sanitation Professional Committee, it
            organises the best companies in sub-sectors as central leaders in
            the construction and application of the internet platform.
          </div>
          <div class="article lh-36">
            As the sanitation industry covers a wide range of areas, the white
            paper focuses on the detailed research and design of domestic waste
            classification and recycling, sweeping, transportation and
            treatment, etc. China Association of Urban Sanitation Smart
            Sanitation Professional Committee will continue to carry out
            in-depth research in other sub-sectors, and the presentation and
            publication of research results will be improved in accordance with
            the guidelines of the authorities of the industry. We will listen to
            the suggestions of professionals from all walks of life and make the
            results available to the whole industry, so please stay tuned.
          </div>
          <!-- <br />
          <div class="lh-36">
            Contents of the White Paper：<br />
            Chapter 1 Preface<br />
            1.1 Background Analysis <br />
            1.2 Objectives and Significance <br />
            Chapter 2: The Current Situation<br />
            2.1 Policy Support<br />
            2.2 Main Achievements <br />
            2.3 Opportunities and Challenges <br />
            Chapter 3 Platforms<br />
            3.1 Concepts and Boundaries<br />
            3.2 Subject Relations<br />
            3.3 User System <br />
            3.4 Construction Models <br />
            3.5 Profit Models <br />
            3.6 Implementation Plan <br />
            Chapter 4 Structure<br />
            4.1 Structural Contents <br />
            4.2 Edge layer<br />
            4.3 IaaS Layer<br />
            4.4 PaaS Layer<br />
            4.5 SaaS Layer<br />
            4.6 Security <br />
            Chapter 5 Standards<br />
            5.1 General Conditions <br />
            5.2 Standard Systems<br />
            5.3 Implementation paths<br />
            Chapter 6 Applications<br />
            6.1 Waste Separation and Recycling<br />
            6.2 Waste Collection and Removal<br />
            6.3 Waste disposal and utilisation<br />
            Chapter 7 Recommendations<br />
            7.1 Government <br />
            7.2 Enterprises<br />
            7.3 Other Recommendations
          </div> -->
          <br />
          <div class="lh-36">
            Copyright notice: This white paper is copyrighted by the China
            Association of Urban Environmental Sanitation and is protected by
            law. If you reproduce, excerpt or otherwise use the text or ideas in
            this white paper, please indicate "Source: China Association of
            Urban Environmental Sanitation". Violators of the above statement
            will be prosecuted for their legal liability.
          </div>
          <br />
          <br />
          <div class="lh-36">
            If you have any further questions, you can contact the Compilation
            Team at the following address.<br />
            Smart Sanitation Professional Committee: zhihuihuanwei@126.com<br />
            Editor-in-chief：Dr. Cao Man caoman@tianren.com<br />
            Executive Editor：Wu Jianmin wujianmin@tianren.com<br />
          </div>
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import count from "@/api/home.js";
import { addConsult } from "@/api/consult";
export default {
  name: "InformationInfo",
  data () {
    var checkPhone = (rule, value, callback) => {
      var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!myreg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      allWidth: 0,
      tag: "cn",
      dialogFormVisible: false,
      form: {},

      rules: {
        askerName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        askerPhone: [
          { required: true, message: "请输入正确的手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "change" }
        ],
        companyName: [
          { required: true, message: "请输入企业名称", trigger: "blur" }
        ],
        // code: [
        //   { required: true, message: "验证码", trigger: "blur" }
        // ]
      }
    };
  },
  created () { },
  mounted () {
    this.allWidth = document.documentElement.clientWidth
    console.log(document.documentElement.clientWidth)
  },
  methods: {
    //打开dialog框
    openDialog () {
      this.form = {
        askerName: "",
        askerPhone: "",
        companyName: "",
        questionDesp: "白皮书下载"
      };
      this.dialogFormVisible = true;
    },
    // 下载
    download () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.form.productName = "智能收运系统";
          this.form.productId = 56;
          addConsult(this.form).then(res => {
            if (res.code == 0) {
              window.open("api/pt/common/downloadFile?tag=" + this.tag);
              this.dialogFormVisible = false;
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 0.32rem;
  padding: 0.24rem 0;
  text-align: center;
}

.box {
  padding: 0 4rem;
  height: auto;
}

.article {
  text-indent: 2em;
}

.lh-36 {
  // line-height: 0.36rem;
}

.lh-35 {
  // line-height: 0.25rem;
  font-size: 0.1rem;
  color: #949699;
}
</style>



// WEBPACK FOOTER //
// src/components/InformationInfoOne.vue